const STORE_NUMBER_KEY = 'store_number';

export const getStoreNumber = (): string | null => localStorage.getItem(STORE_NUMBER_KEY);

export const setStoreNumber = (storeNumber: string): void => {
  localStorage.setItem(STORE_NUMBER_KEY, storeNumber);
};

export const clearStoreNumber = (): void => {
  localStorage.removeItem(STORE_NUMBER_KEY);
};
